import React from 'react';
import { get, find } from 'lodash';

// local dependencies
import { memberBusinessProcessTodo as MemberBusinessProcessTodoView } from 'ui/views/widgets/memberBusinessProcessTodo';
import { MemberBusinessProcessTodoService } from 'services/memberBusinessProcessTodo';
import * as pageLevelPreloader from 'modules/page-level-preloader';
import * as errorOverlay from 'utils/errorOverlay';
import * as successOverlay from 'utils/successOverlay';
import { GLOBAL_LABELS } from 'constants/common';
import { getLabel } from 'utils/getLabel';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { MemberBusinessProcessTodo } from 'ui/containers/MemberBusinessProcessTodo';
 *
 * // render
 * <MemberBusinessProcessTodo propName='propValue'/>
 */
export class MemberBusinessProcessTodo extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        // create service instance
        this.memberBusinessProcessTodoService = new MemberBusinessProcessTodoService();

        // bind function(s)
        this.onFormSubmit = this.onFormSubmit.bind( this );
    }

    /**
     * @desc executes when user submits form
     */
    async onFormSubmit( formData ) {
        log.debug( 'MemberBusinessProcessTodo.onFormSubmit()' );

        const context = get( this.props, 'context', {} );
        const successAction = find( this.props.actions, { name: 'submit' } );

        // close overlay
        this.props.onCancelClick();

        // show page preloader
        pageLevelPreloader.show();

        const { status } = await this.memberBusinessProcessTodoService.submitFormData( {
            url: successAction.url,
            data: {
                context,
                data: formData
            }
        } );

        // hide page preloader
        pageLevelPreloader.hide();

        if( SERVICE_RESPONSE_STATUS.SUCCESS === status ) {
            successOverlay.open( { message: getLabel( GLOBAL_LABELS.DISPLAY_TEXT_DONE_SUCCESSFULLY ), } );

        } else {
            errorOverlay.open();
        }
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <MemberBusinessProcessTodoView
                { ...this.props }
                onFormSubmit={ this.onFormSubmit }
            />
        );
    }
}

// set display name
MemberBusinessProcessTodo.displayName = 'MemberBusinessProcessTodo';

// set default props
MemberBusinessProcessTodo.defaultProps = {};

// prop types
MemberBusinessProcessTodo.propTypes = {};
